<div class="type-main">
  <div class="nav-bar">
    <div class="back-holder" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
    <div class="nav-bar-title">انتخاب هدف</div>
  </div>
  <div class="type-title">هدف برنامه غذایی خود را مشخص کنید.</div>
  <div class="type-container">
    <app-button
      *ngFor="let configButton of configButtons"
      [config]="configButton"
      class="type-button"
    ></app-button>
  </div>
</div>
